import { LoginForm } from '@/components/auth/login-form'
import { createFileRoute } from '@tanstack/react-router'
import type { JSX } from 'react'

export const Route = createFileRoute('/_public/login')({
  component: LoginPage,
})

function LoginPage(): JSX.Element {
  return <LoginForm />
}
